import React from "react";
import { seatLabel } from "../lib/api";

export default function SeatMap({ tier, selected, onToggle }) {
  const booked = new Set(tier.booked_seats || []);
  return (
    <div data-testid="seat-map" className="rounded-2xl border border-zinc-800 bg-[#33101C] p-4">
      <div className="mb-3 rounded-lg bg-gradient-to-b from-amber-500/30 to-transparent py-1 text-center font-mono text-[10px] uppercase tracking-[0.4em] text-amber-300">Stage</div>
      <div className="overflow-x-auto">
        <div className="mx-auto w-max space-y-1.5">
          {Array.from({ length: tier.rows }).map((_, r) => (
            <div key={r} className="flex items-center gap-1.5">
              <span className="w-4 font-mono text-[10px] text-zinc-500">{String.fromCharCode(65 + r)}</span>
              {Array.from({ length: tier.cols }).map((_, c) => {
                const label = seatLabel(r, c);
                const isBooked = booked.has(label);
                const isSel = selected.includes(label);
                return (
                  <button
                    key={label} type="button" disabled={isBooked} title={label}
                    data-testid={`seat-${label}`}
                    onClick={() => onToggle(label)}
                    className={`h-6 w-6 rounded-t-md text-[9px] font-mono transition ${
                      isBooked ? "cursor-not-allowed bg-zinc-800 text-zinc-600"
                        : isSel ? "scale-110 bg-amber-500 text-zinc-950 shadow-[0_0_12px_rgba(242,199,210,.6)]"
                        : "bg-zinc-700/70 text-zinc-300 hover:bg-punch-500 hover:text-white"}`}
                  >{c + 1}</button>
                );
              })}
            </div>
          ))}
        </div>
      </div>
      <div className="mt-4 flex flex-wrap gap-4 text-[10px] font-mono uppercase tracking-widest text-zinc-500">
        <span className="flex items-center gap-1.5"><i className="h-3 w-3 rounded-sm bg-zinc-700/70" />Open</span>
        <span className="flex items-center gap-1.5"><i className="h-3 w-3 rounded-sm bg-amber-500" />Yours</span>
        <span className="flex items-center gap-1.5"><i className="h-3 w-3 rounded-sm bg-zinc-800" />Taken</span>
      </div>
    </div>
  );
}
